<template>
    <div class="flex items-start">

        <figure class="" style="position: relative">
            <img src="../../../img/wall-builder/layers/empty.png" alt=""/>
            <img class="absolute top-0" src="../../../img/wall-builder/layers/00-foundation.jpg" alt=""/>
            <!-- Base Wall -->

            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.baseWall.value === 'masonry'" src="../../../img/wall-builder/layers/01-mason.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.baseWall.value === 'steel-frame'" src="../../../img/wall-builder/layers/01-steel.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.baseWall.value === 'wood-frame'" src="../../../img/wall-builder/layers/01-wood.png" alt=""/></Transition>

            <!-- Insulation -->

            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.baseWall.value == 'steel-frame' && options.cavityInsulation.value === 'yes'" src="../../../img/wall-builder/layers/01-steel-batt.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.baseWall.value == 'wood-frame' && options.cavityInsulation.value === 'yes'" src="../../../img/wall-builder/layers/01-wood-batt.png" alt=""/></Transition>

            <!-- TODO: Add spray foam option -->

            <!-- Sheathing -->
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.sheathing.value == 'gypsum'" src="../../../img/wall-builder/layers/02-gypsum.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.sheathing.value == 'plywood'" src="../../../img/wall-builder/layers/02-plywood.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.sheathing.value == 'other'" src="../../../img/wall-builder/layers/02-other.png" alt=""/></Transition>

            <!-- WRB -->

            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.sheathing.value !== 'none' && options.insideWrb.value == 'liquid'" src="../../../img/wall-builder/layers/03-WRB-liq-in-CMU.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.sheathing.value !== 'none' && options.insideWrb.value == 'sheet'" src="../../../img/wall-builder/layers/03-WRB-sheet-in.png" alt=""/></Transition>


            <!-- Insulation Product -->
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.insulationProduct.value == 'energyshield'" src="../../../img/wall-builder/layers/04-ES.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.insulationProduct.value == 'energyshield-pro'" src="../../../img/wall-builder/layers/04-ES-Pro.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.insulationProduct.value == 'energy-cgf-pro'" src="../../../img/wall-builder/layers/04-CGF-Pro.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.insulationProduct.value == 'energyshield-ply-pro'" src="../../../img/wall-builder/layers/04-Ply-Pro.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.insulationProduct.value == 'energyshield-ply-pro-wrb'" src="../../../img/wall-builder/layers/04-Ply-Pro-WRB.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.insulationProduct.value == 'energyshield-cgf'" src="../../../img/wall-builder/layers/04-CGF.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.insulationProduct.value == 'energyshield-xr'" src="../../../img/wall-builder/layers/04-ESXR.png" alt=""/></Transition>


            <!-- Outside WRB -->

            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.outsideWrb.value == 'iso-as-wrb'" src="../../../img/wall-builder/layers/05-WRB-ISO-tape.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.outsideWrb.value == 'liquid'" src="../../../img/wall-builder/layers/05-WRB-liq-out.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.outsideWrb.value == 'sheet'" src="../../../img/wall-builder/layers/05-WRB-sheet-out.png" alt=""/></Transition>

            <!-- Cladding -->
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'mcm-acm'" src="../../../img/wall-builder/layers/07-metal.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'masonry'" src="../../../img/wall-builder/layers/07-masonry.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'cement-board'" src="../../../img/wall-builder/layers/07-concreteboard.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'stucco'" src="../../../img/wall-builder/layers/07-stucco.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'stone'" src="../../../img/wall-builder/layers/07-natural_stone.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'wood'" src="../../../img/wall-builder/layers/07-wood.png" alt=""/></Transition>


            <!-- Masonry cladding types -->
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'masonry' && options.masonryCladdingType.value === 'brick'" src="../../../img/wall-builder/layers/07-brick.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'masonry' && options.masonryCladdingType.value === 'terracota'" src="../../../img/wall-builder/layers/07-terracota.png" alt=""/></Transition>
            <Transition name="slide-fade"><img class="absolute top-0" v-if="options.cladding.value == 'masonry' && options.masonryCladdingType.value === 'stone'" src="../../../img/wall-builder/layers/07-stone.png" alt=""/></Transition>
        </figure>
    </div>
</template>

<style>
.slide-fade-enter-active  {
    transition: all 0.3s ease-out;
}

.slide-fade-leave-active  {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from {
    transform: translateX(20px);
    opacity: 0;
}
.slide-fade-leave-to {
    transform: translateX(-20px);
    opacity: 0;
}

</style>

<script>
import * as images from "../../../img/wall-builder/layers";

export default {
    data() {
        return {
            images
        }
    },
    props: {
        options: {
            type: Object,
            required: true,
        }
    }
}
</script>
